module.exports = __webpack_public_path__ + "media/images/for-talent-bg-bf9f8c2f393319aa3b50f91522a2bc6b.png";